import {Signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {BuildingServices} from '@brunata-angular/util';
import {loadedUserHoldsBuildingService} from '@shared/route-utils';

/** Undefined until the user has loaded. Call from an injection context. */
export const injectHoldsAdvancedDelivery = (): Signal<boolean | undefined> =>
    toSignal(loadedUserHoldsBuildingService(BuildingServices.ASE_ADVANCED_DELIVERY));
